var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function HomeIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.00087 20L8 20.0006V13.9975C8 13.4466 8.44726 13 8.99703 13H15.003C15.5536 13 16 13.4463 16 13.9975V20.0026L19 20.0044V10.4162L12 3.42236L4.99995 10.4163C4.99974 12.3077 5.00087 20 5.00087 20ZM2.70711 12.7071C2.31658 13.0976 1.68342 13.0976 1.29289 12.7071C0.902369 12.3166 0.902369 11.6834 1.29289 11.2929L11.2929 1.29289C11.6834 0.902369 12.3166 0.902369 12.7071 1.29289L22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071C22.3166 13.0976 21.6834 13.0976 21.2929 12.7071L21 12.4145V20.0044C21 21.1084 20.1058 22 18.9991 22H5.00087C3.89683 22 3 21.1085 3 20.0044V12.4145L2.70711 12.7071ZM14 20.002V14.9984L10 15V20.001L14 20.002Z", fill: "" })));
}
export var HomeIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: HomeIconInner }, props))); };
//# sourceMappingURL=HomeIcon.js.map